<template>
  <TemplateView>
    <v-container>
      <div class="d-grid mb-4">
        <div class="d-flex flex-column">
          <label class="primary--text f14 fw500 temp">
            {{ localStorage.translations.pages['statistic_project'].tables.period }}
          </label>
          <div class="d-flex flex-wrap">
            <v-menu
                ref="menu"
                v-model="menu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                    hide-details
                    v-model="dateRangeText"
                    filled
                    height="30"
                    v-bind="attrs"
                    readonly
                    prepend-inner-icon="today"
                    placeholder="—"
                    v-on="on"
                    class="temp"
                />
              </template>
              <v-date-picker
                  :locale="$cookies.get('languageSelect').key"
                  v-model="filter.period"
                  range
                  no-title
                  show-week
                  first-day-of-week="1"
                  :max="new Date().toISOString().slice(0, 10)"
              >
                <BaseButton
                    class="ml-auto mr-0"
                    :text="localStorage.translations.pages.common.buttons.confirm"
                    :disabled="filter.period.length < 1"
                    @click=";(menu = false), onDownloadData(true)"
                />
              </v-date-picker>
            </v-menu>
          </div>

        </div>
      </div>
      <div class="d-grid gap-6 grid-col-md-1-2">
        <div v-if="$vuetify.breakpoint.xs">
          <BaseCard>
            <div class="d-grid gap-3">
              <div
                  class="d-grid grid-row-1-1 gap-2 pa-2 filterList filterList-mobile totalLine-mobile"
                  @click="onFilterStatusWidget()"
              >
                <div>
                  <span class="fw500 primary--text">{{ translation.total }}</span>
                </div>
                <div class="d-grid grid-col-1-1 gap-7">
                  <div class="d-flex align-center justify-space-between">
                    <span class="fw700 primary--text"> {{ totalCountStatic }} </span>
                    <span class="fw700 primary--text"> kpl </span>
                  </div>
                  <div class="d-flex align-center justify-space-between">
                    <span class="fw700 primary--text"> {{ totalSumStatic }} </span>
                    <span class="fw700 primary--text"> € </span>
                  </div>
                </div>
              </div>
              <template v-for="(i, m) in widgetListDataStatic">
                <div :key="m + 'mobile'"
                     :class="filter.status.value === i.status ? 'activeStatus' : ''"
                     @click="onFilterStatusWidget(i.status)">
                  <div
                      :key="m + 'mobileName'"
                      class="d-grid grid-row-1-1 gap-2 pa-2 filterList filterList-mobile"
                  >
                    <div class="d-flex align-center justify-space-between">
                      <span class="primary--text mr-2"> {{ i.name }} </span>
                      <v-avatar :color="i.color" size="20px" :key="m + 'avatar'"/>
                    </div>
                    <div class="d-grid grid-col-1-1 gap-8">
                      <div class="d-flex align-center justify-space-between">
                        <span> {{ i.count }} </span>
                        <span v-if="i.status !== 'new'"> kpl </span>
                      </div>
                      <div class="d-flex align-center justify-space-between">
                        <span> {{ i.amount }} </span>
                        <span> € </span>
                      </div>
                    </div>
                  </div>
                </div>
                <template v-if="i.status === 'in_progress'">
                  <div
                      v-for="(item, jm) in widgetListTreeDataStatic"
                      :key="m + '_' + jm"
                      class="d-grid grid-row-1-1 gap-2 pa-2 filterList inner filterList-mobile"
                      :class="filter.status.value === item.status ? 'activeStatus' : ''"
                      @click="onFilterStatusWidget(item.status)"
                  >
                    <div
                        :key="item + jm + 'name'"
                        class="d-flex align-center justify-space-between"
                    >
                      <span class="primary--text mr-2">{{ item.name }}</span>
                      <v-avatar :color="item.color" size="20px" :key="jm + 'avatar'"/>
                    </div>
                    <div class="d-grid grid-col-1-1 gap-7 ml-3">
                      <div
                          :key="item + jm + 'count'"
                          class="d-flex align-center justify-space-between"
                      >
                        <span> {{ item.count }} </span>
                        <span> kpl </span>
                      </div>
                      <div
                          :key="item + jm + 'amount'"
                          class="d-flex align-center justify-space-between"
                      >
                        <span> {{ item.amount }} </span>
                        <span> € </span>
                      </div>
                    </div>
                    <div :class="jm === 0 ? 'inner-border-mobile-first' : 'inner-border-mobile'"/>
                  </div>
                </template>
              </template>
            </div>
          </BaseCard>
          <div class="mt-6 d-grid gap-2 grid-row-1-1-1">
            <BaseCard
                v-for="(i, k) in indicatorsDataStatic"
                :key="k + 'item'"
                :title="i.title"
                :class-title="i.color + 'f16 w-100 text-center'"
            >
              <span :class="i.color + ' text-center f48 fw500'">{{ i.content }}</span>
            </BaseCard>
          </div>
        </div>
        <div v-else>
          <BaseCard>
            <div class="d-flex flex-column align-stretch justify-space-between">
              <div v-if="widgetDataStatic.length > 0">
                <BaseWidget  circular :items="widgetDataStatic" :show-percent="false"/>
                <div
                    class="d-grid grid-col-2-1-auto-1 gap-5 my-5 pa-2 totalLine filterList"
                    @click="onFilterStatusWidget()"
                >
                  <span class="fw500 primary--text">
                    {{ translation.total + ': ' }}
                  </span>
                  <span class="fw700 primary--text"> {{ totalSumStatic }} € </span>
                  <v-avatar color="transparent" size="20px"/>
                  <span class="fw500 text-end"> {{ totalCountStatic }} kpl</span>
                </div>
                <div>
                  <template v-for="(cust, c) in widgetListDataStatic">
                    <div
                        :key="c + 'main'"
                        class="d-grid grid-col-2-1-auto-1 gap-5 px-2 py-1 filterList"
                        :class="filter.status.value === cust.status ? 'activeStatus' : ''"
                        @click="onFilterStatusWidget(cust.status)"
                    >
                      <div :key="c + 'name'">
                        <span class="primary--text fw300 f16"> {{ cust.name }} </span>
                      </div>
                      <div :key="c + 'amount'">
                        <span class="f16 fw300 text-start primary--text"> {{ cust.text }} </span>
                      </div>
                      <v-avatar :color="cust.color" size="20px" :key="c + 'avatar'"/>
                      <div class="d-flex align-center justify-end">
                        <span class="fw300 text-end" :key="c + 'count'">{{ cust.count }} </span>
                        <span v-if="cust.status && cust.status !== 'new'" class="fw300 text-end ml-1"> kpl</span>
                      </div>
                    </div>
                    <template v-if="cust.status && cust.status === 'in_progress'">
                      <div
                          v-for="(item, j) in widgetListTreeDataStatic"
                          :key="c + '_' + j"
                          class="d-grid grid-col-2-1-auto-1 gap-5 px-2 py-1 filterList"
                          :class="filter.status.value === item.status ? 'activeStatus' : ''"
                          @click="onFilterStatusWidget(item.status)"
                      >
                        <div :key="c + 'item' + j + 'name'" class="inner">
                          <span class="primary--text fw300 f16">{{ item.name }}</span>
                          <div :class="j === 0 ? 'inner-border-first' : 'inner-border'"/>
                        </div>
                        <div :key="c + 'item' + j + 'amount'">
                          <span class="f16 fw300 text-start primary--text"> {{ item.text }} </span>
                        </div>
                        <v-avatar
                            :color="item.color"
                            size="20px"
                            :key="c + 'item' + j + 'avatar'"
                        />
                        <span class="fw300 text-end" :key="c + 'item' + j + 'count'"> {{ item.count }} kpl</span>
                      </div>
                    </template>
                  </template>
                </div>
              </div>
              <Plug v-else/>
            </div>
          </BaseCard>
          <div class="mt-6 d-grid gap-4 grid-col-md-1-1-1">
            <BaseCard
                v-for="(i, k) in indicatorsDataStatic"
                :key="k + 'item'"
                :title="i.title"
                :class-title="i.color + ' f16 w-100 text-center'"
            >
              <span :class="i.color + ' text-center f36 fw500'"> {{ i.content }} </span>
            </BaseCard>
          </div>
        </div>
        <TemplatePageGrid
            :items="workClientProjectAllReports.reports && workClientProjectAllReports.reports.data || []"
            :page-data="workClientProjectAllReports.reports"
            :loading="loadingAnimation"
        >
          <div class="mb-6" slot="buttons">
            <div class="d-flex flex-wrap gap-5">
              <BaseInput
                  type="autocomplete"
                  v-model="filter.project.value"
                  :items="filter.project.list"
                  :label="translation.project"
                  v-bind="bindInput"
                  @change="onDownloadData()"
                  :key="'project' + key"
              />
              <BaseInput
                  type="autocomplete"
                  v-model="filter.client.value"
                  :items="filter.client.list"
                  :label="localStorage.translations.pages['sales_project']['project_client-labels']['klient']"
                  v-bind="bindInput"
                  @change="onDownloadData()"
              />
              <BaseInput
                  type="autocomplete"
                  v-model="filter.weeks.value"
                  :items="filter.weeks.list"
                  :label="translation['week_number']"
                  v-bind="bindInput"
                  item-value="week"
                  item-text="week"
                  @change="onDownloadData()"
              />
              <BaseInput
                  type="autocomplete"
                  v-model="filter.status.value"
                  :items="filter.status.list"
                  :label="translation['status_report']"
                  v-bind="bindInput"
                  :multiple="false"
                  @change="onDownloadData()"
                  :key="'status' + filter.status.value"
              />
            </div>
          </div>
          <ProjectReportsTable
              v-if="workClientProjectAllReports.reports"
              :items="workClientProjectAllReports.reports.data"
          />
        </TemplatePageGrid>
      </div>
    </v-container>
  </TemplateView>
</template>

<script>
import TemplateView from 'components/templates/TemplateView.vue'
import BaseCard from 'components/base/BaseCard.vue'
import BaseWidget from 'components/base/widget/BaseWidget.vue'
import ProjectReportsTable from 'components/project/projectReports/ProjectReportsTable.vue'
import TemplatePageGrid from 'components/templates/TemplatePageGrid.vue'
import {mapActions, mapGetters, mapMutations} from 'vuex'
import Plug from "../../components/Plug.vue";

export default {
  name: 'salesProjectReports',
  components: {Plug, TemplatePageGrid, ProjectReportsTable, BaseWidget, BaseCard, TemplateView},
  data: () => ({
    bindInput: {
      multiple: true,
      minimize: true,
      'small-chips': true,
      clearable: true,
      placeholder: "—",

    },
    menu: false,
    key: 0,
    filter: {
      period: [],
      project: {
        list: [],
        value: [],
      },
      client: {
        list: [],
        value: [],
      },
      weeks: {
        list: [],
        value: [],
        result: [],
      },
      status: {
        list: [],
        value: null,
      },
    },
    widgetDataStatic: [],
    widgetListDataStatic: [],
    widgetListTreeDataStatic: [],
    indicatorsDataStatic: [],
    totalSumStatic: '',
    totalCountStatic: '',
    allFields: {
      'new': 'var(--v-primary-lighten1)',
      'in_progress': 'var(--v-primary-base)',
      'approved': 'var(--v-success-lighten5)',
      'sent': 'var(--v-warning-lighten1)',
      'viewed': 'var(--v-warning-base)',
      'expired': 'var(--v-error-base)',
      'signed': 'var(--v-success-base)',
    },
    indicatorNames: [
      {
        name: 'new',
        color: 'primary--text text--lighten-1',
      },
      {
        name: 'in_progress',
        color: 'primary--text text--base',
      },
      {
        name: 'signed',
        color: 'success--text text--base',
      },
    ],
    lastMonthPeriod: [],
    currentMonth: '',
  }),
  computed: {
    ...mapGetters('workClientProject', ['workClientProjectAllReports']),
    ...mapGetters(['loadingAnimation']),
    translation() {
      return this.localStorage.translations.pages.projects['reports_table']
    },
    totalSum() {
      return this.workClientProjectAllReports.statistic ? this.workClientProjectAllReports.statistic.sum : ''
    },
    totalCount() {
      return this.workClientProjectAllReports.statistic ? this.workClientProjectAllReports.statistic.count : ''
    },
    widgetListNames() {
      let result = []
      for (let i in this.allFields)
        result.push({
          name: i,
          color: this.allFields[i]
        })
      return result
    },
    widgetNames() {
      let result = []
      let list = ['new', 'sent', 'viewed', 'expired', 'approved', 'signed']
      for (let i in list)
        result.push({
          name: list[i],
          color: this.allFields[list[i]]
        })
      return result
    },
    dateRangeText() {
      let dates = [...this.filter.period]
      if (dates[0]) {
        dates[0] = this.$formatDate(dates[0])
      }
      if (dates[1]) {
        dates[1] = this.$formatDate(dates[1])
      }
      if (dates[0] && dates[1] && dates[0] > dates[1]) {
        dates = [dates[1], dates[0]]
      }
      return dates.join(' - ')
    },
    widgetData() {
      let total_result = []

      let result = []
      let temp = this.workClientProjectAllReports.statistic
          && this.workClientProjectAllReports.statistic.statuses

      let result_inner = []
      let temp_inner = this.workClientProjectAllReports.statistic
          && this.workClientProjectAllReports.statistic.statuses.in_progress.statuses

      let names = this.widgetNames
      for (let n in names) {
        let name = names[n].name
        let color = names[n].color
        if (temp && temp[name] && temp[name].price > 0) {
          result.push({
            name: this.translation[name] || name,
            color: color,
            count: temp[name].price,
            text: this.$formatCurrency(temp[name].price) + ' €',
            amount: this.$formatCurrency(temp[name].price),
          })
        }
        if (temp_inner && temp_inner[name] && temp_inner[name].price > 0) {
          result_inner.push({
            name: this.translation[name] || name,
            color: color,
            count: temp_inner[name].price,
            text: this.$formatCurrency(temp_inner[name].price) + ' €',
            amount: this.$formatCurrency(temp_inner[name].price),
          })
        }
      }
      total_result = result.concat(result_inner)
      return total_result
    },
    widgetListData() {
      let result = []
      let temp = this.workClientProjectAllReports.statistic
          && this.workClientProjectAllReports.statistic.statuses

      let names = this.widgetListNames
      for (let n in names) {
        let name = names[n].name
        let color = names[n].color
        if (temp && temp[name]) {
          result.push({
            name: this.translation[name] || name,
            color: color,
            status: name,
            count: temp[name].count,
            text: this.$formatCurrency(temp[name].price) + ' €',
            amount: this.$formatCurrency(temp[name].price),
          })
        }
      }
      return result
    },
    widgetListTreeData() {
      let result = []
      let temp = this.workClientProjectAllReports.statistic
          && this.workClientProjectAllReports.statistic.statuses.in_progress.statuses

      let names = this.widgetListNames
      for (let n in names) {
        let name = names[n].name
        let color = names[n].color
        if (temp && temp[name]) {
          result.push({
            name: this.translation[names[n].name] || name,
            color: color,
            status: name,
            count: temp[name].count,
            text: this.$formatCurrency(temp[name].price) + ' €',
            amount: this.$formatCurrency(temp[name].price),
          })
        }
      }
      return result
    },
    indicatorsData() {
      let result = []
      let temp = this.workClientProjectAllReports.statistic
          && this.workClientProjectAllReports.statistic.statuses
      let names = this.indicatorNames

      for (let n in names) {
        let name = names[n].name
        let color = names[n].color
        result.push({
          title: this.translation[name],
          color: color,
          content: temp && temp[name] ? temp[name].percent.toFixed(2) + '%' : '0%',
        })
      }
      return result
    },
  },
  watch: {
    '$route.query'() {
      this.onDownloadData()
    },
    widgetData() {
      if (this.widgetData && this.widgetData.length > 0) {
        this.widgetDataStatic = this.widgetData
        this.widgetListDataStatic = this.widgetListData
        this.widgetListTreeDataStatic = this.widgetListTreeData
        this.indicatorsDataStatic = this.indicatorsData
        this.totalSumStatic = this.$formatCurrency(this.totalSum)
        this.totalCountStatic = this.totalCount
      }
    },
  },
  created() {
    this.firstPeriodDateData()
    this.onDownloadData()
  },
  methods: {
    ...mapActions('workClientProject', ['onWorkClientProjectAllReports']),
    ...mapMutations(['setLoadingAnimation']),
    selectedDates({start, end}) {
      let obj = {}
      obj.dates = this.$getDates(start, end)
      obj.weeks = []
      for (let date of obj.dates) {
        if (!obj.weeks.find((i) => i.week === date.getWeek())) obj.weeks.push({
          week: date.getWeek(),
          year: date.getFullYear()
        })
      }
      return obj
    },
    firstPeriodDateData() {
      let currentDate = new Date();
      let dd = currentDate.getDate()
      let mm = currentDate.getMonth() + 1
      let yyyy = currentDate.getFullYear()
      this.filter.period = []
      let currentMonth = new Date(yyyy, mm, 0).getDate()
      let lastMonth = new Date(yyyy, mm-1, 0).getDate()
      if(currentMonth > lastMonth) {

        let tempDay = dd - (dd - lastMonth)
        this.filter.period.push(String(yyyy + '-' + String(mm == 1 ? 12 : mm - 1,).padStart(2, '0') + '-' + String(tempDay).padStart(2, '0')))
        this.filter.period.push(String(yyyy + '-' + String(mm).padStart(2, '0') + '-' + String(dd).padStart(2, '0')))
        console.log('!!!!', tempDay)
      } else {
        this.filter.period.push(String(yyyy + '-' + String(mm == 1 ? 12 : mm - 1,).padStart(2, '0') + '-' + String(dd).padStart(2, '0')))
        this.filter.period.push(String(yyyy + '-' + String(mm).padStart(2, '0') + '-' + String(dd).padStart(2, '0')))
      }

      this.lastMonthPeriod = this.filter.period
      this.currentMonth = mm
    },
    async onDownloadData(resetPeriod) {

      let local = localStorage.getItem('periodStatisticReport')
          ? JSON.parse(localStorage.getItem('periodStatisticReport'))
          : {period: this.filter.period, month: this.currentMonth}
      if (resetPeriod || (local && local.month < this.currentMonth)) {
        local.period = this.filter.period
      }
      this.filter.period = local.period
      this.setLoadingAnimation(true)
      let data = {
        filter: {
          period: this.filter.period,
        },
        limit: this.$route.query.limit,
        page: this.$route.query.page,
      }
      if (this.filter.period && this.filter.period.length && this.filter.period[1] && this.filter.period[0] > this.filter.period[1])
        data.filter.period = [this.filter.period[1], this.filter.period[0]]
      if (this.filter.period && this.filter.period.length && !this.filter.period[1]) {
        this.filter.period[1] = this.filter.period[0]
        data.filter.period = [data.filter.period[0], data.filter.period[1]]
      }
      if (this.filter.client.value && this.filter.client.value.length)
        data.filter.client = this.filter.client.value
      if (this.filter.project.value && this.filter.project.value.length)
        data.filter.project = this.filter.project.value
      if (this.filter.status.value && this.filter.status.value.length)
        data.filter.status = this.filter.status.value
      if (this.filter.weeks.value && this.filter.weeks.value.length) {
        let week_result = []
        for (let w in this.filter.weeks.value) {
          week_result = week_result.concat(this.filter.weeks.list.filter(data => data.week == this.filter.weeks.value[w]))
          this.filter.weeks.result = week_result
        }
        if (this.filter.weeks.result && this.filter.weeks.result.length)
          data.filter.weeks = this.filter.weeks.result
      }
      if (this.$route.query.sort_param && this.$route.query.sort_value) {
        data.sort = {
          param: this.$route.query.sort_param,
          value: this.$route.query.sort_value,
        }
      }
      await this.onWorkClientProjectAllReports(data).then((res) => {
        this.filter.client.list = res.data.filter.clients

        this.filter.status.list = [
          {id: 'new', name: this.translation.new},
          {id: 'in_progress', name: this.translation['in_progress']},
          {id: 'approved', name: this.translation.approved},
          {id: 'sent', name: this.translation.sent},
          {id: 'viewed', name: this.translation.viewed},
          {id: 'expired', name: this.translation.expired},
          {id: 'signed', name: this.translation.signed},
          {id: 'done', name: this.translation.done},
        ]
        // let temp = res.data.filter.statuses
        // for (let i in temp) {
        //   this.filter.status.list.push({
        //     id: temp[i],
        //     name: this.translation[temp[i]] || temp[i]
        //   })
        // }
        this.filter.project.list = []
        let client_temp = res.data.filter.clients
        for (let t in client_temp) {
          let project_temp = res.data.filter.clients[t].projects
          for (let p in project_temp) {
            this.filter.project.list.push({
              id: res.data.filter.clients[t].projects[p].id,
              name: res.data.filter.clients[t].projects[p].name
            })
          }
        }
        this.filter.weeks.list = this.selectedDates({
          start: data.filter.period[0],
          end: data.filter.period[1]
        }).weeks
        this.setLoadingAnimation(false)
        localStorage.setItem('periodStatisticReport', JSON.stringify({
          period: data.filter.period,
          month: this.currentMonth
        }))
      })
    },
    onFilterStatusWidget(data) {
      this.filter.status.value = data
      this.onDownloadData()
    }
  },
}
</script>

<style scoped lang="scss">
.inner {
  margin-left: 15px;
  position: relative;

  &-border {
    position: absolute;
    top: -100%;
    left: -15px;
    width: 10px;
    height: 140%;
    border-bottom: 1px dotted var(--v-primary-base);
    border-left: 1px dotted var(--v-primary-base);

    &-first {
      position: absolute;
      top: -30%;
      left: -15px;
      width: 10px;
      height: 80%;
      border-bottom: 1px dotted var(--v-primary-base);
      border-left: 1px dotted var(--v-primary-base);
    }

    &-mobile {
      position: absolute;
      top: -60%;
      left: -10px;
      width: 10px;
      height: 120%;
      border-bottom: 1px dotted var(--v-primary-base);
      border-left: 1px dotted var(--v-primary-base);

      &-first {
        position: absolute;
        top: -15%;
        left: -10px;
        width: 10px;
        height: 75%;
        border-bottom: 1px dotted var(--v-primary-base);
        border-left: 1px dotted var(--v-primary-base);
      }
    }
  }
}

.filterList {
  border: 1px solid transparent;

  &-new {
    font-weight: 700 !important;
  }

  &-mobile {
    border: 1px solid var(--v-secondary-lighten4);
  }

  &:hover {
    cursor: pointer;
    border: 1px solid var(--v-secondary-base);
  }
}

.activeStatus {
  border: 1px solid var(--v-secondary-base);
  background-color: var(--v-secondary-lighten4);
}

.totalLine {
  background-color: var(--v-secondary-lighten4);

  &-mobile {
    border: 1px solid var(--v-secondary-lighten4);
  }
}

label.temp {
  display: block;
  margin-bottom: 5px;
  line-height: 16px !important;
}

:deep() .v-input.v-text-field .v-input__slot:not(.v-textarea) {
  min-height: 30px !important;
  border-radius: 10px !important;
}

:deep() .v-sheet.v-card {
  border-radius: 10px !important;
}

.temp {
  :deep() .v-input__slot {
    width: max-content !important;
  }
}

</style>